<kui-dropdown
    #dropdown
    [style]="'none'"
    [outlined]="true"
    [disabled]="disabled()"
    [isFormControl]="isFormStyle()"
    classNames="kui-daterange-popup-new"
    [class.w-100]="isFormStyle()"
    [customContent]="filterOperator"
>
    <div class="input-group selected-values">
        @if (customContent()) {
            <ng-content></ng-content>
        } @else {
            @if (icon()) {
                <kui-icon
                    [name]="icon()"
                    class="selected-values__icon"
                    [ngClass]="{
                        'input-group-addon': this.isFormStyle(),
                    }"
                />
            }

            @if (selectedStartDate() && selectedEndDate()) {
                <div class="selected-values__dates" [class.form-control]="this.isFormStyle()">
                    <span>{{ timePeriodDisplayText() }}</span>
                </div>
            } @else {
                <span class="selected-values__placeholder" [class.form-control]="this.isFormStyle()">
                   {{ noDatePlaceholder() ?? "SHARED.NONE" | translate }}
                </span>
            }

            <kui-icon
                name="caret-down"
                class="selected-values__icon"
                [ngClass]="{
                    'input-group-addon': this.isFormStyle(),
                }"
            />
        }
    </div>
</kui-dropdown>

<ng-template #filterOperator>
    <div class="date-selector__panel">
        <div kui-list class="date-selector__time-periods time-periods">
            @if (timePeriods()) {
                @for (period of timePeriods(); track period.id) {
                    <button kui-list-item type="action" [isActive]="period.id === internalTimePeriod()?.id && !customDateRange()" (click)="handleTimePeriod(period)">
                        @switch (period.id) {
                            @case ('last7Days') {
                                {{ last7DaysText() }}
                            }
                            @case ('last30days') {
                                {{ last30DaysText() }}
                            }
                            @default {
                                {{ period.text }}
                            }
                        }
                    </button>
                }
            }

            @if (customDatePicker()) {
                <button kui-list-item type="action" [isActive]="customDateRange()" (click)="toggleDateRangePicker()">
                    {{ 'REPORTING.ITEMS.FIELDS.VALUES.CUSTOM_DATE_RANGE' | translate}}
                </button>
            }
        </div>
        
        @if (showDateRangePicker()) {
            <div class="date-selector__calendar">
                <p-datepicker
                    panelStyleClass="kui-calendar"
                    selectionMode="range"
                    [readonlyInput]="true"
                    [ngModel]="customDateRange()"
                    (ngModelChange)="customDateRange.set($event)"
                    [minDate]="minDate()"
                    [maxDate]="maxDate()"
                    [inline]="true"
                    [showTime]="useTime()"
                    [showSeconds]="useTime()"
                    [hourFormat]="hourFormat()"
                    (onSelect)="handleCalendarDateSelection()"
                />
            </div>

            <button 
                kui-button
                class="date-selector__confirm confirm" 
                [disabled]="!startCalendarDate() || !endCalendarDate()"
                (click)="confirmDates()"
            >
                {{submitButtonText() ?? 'DIALOG.APPLY' | translate}}
            </button>

        }
    </div>
</ng-template>
